import script from "./TeacherStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherStudent.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./TeacherStudent.vue?vue&type=style&index=1&id=62d4049f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d4049f"]])

export default __exports__